module.exports = ".logo-bckg {\n  position: absolute;\n  top: 23%; }\n\nlabel {\n  margin-bottom: 0.8rem; }\n\n.form-group {\n  margin-bottom: 1.5rem; }\n"